import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Home from "./pages/Home";
import Auth from "./pages/Auth";
import PostDetail from "./pages/PostDetail";
import Archive from "./pages/Archive";
import About from "./pages/About";
import WritePost from "./pages/WritePost";
import NotFound from "./pages/NotFound";

import { defaultPosts, defaultAboutInfoTemplate } from "./api/mockData";

export default function App() {
  const [loggedInUser, setLoggedInUser] = useState(null);

  const handleLogin = (user) => setLoggedInUser(user);
  const handleRegister = (user) => setLoggedInUser(user);
  const handleLogout = () => setLoggedInUser(null);

  const [posts, setPosts] = useState(defaultPosts);
  const handleAddPost = (newPost) => setPosts([newPost, ...posts]);

  const [aboutInfo, setAboutInfo] = useState(defaultAboutInfoTemplate);
  const handleUpdateAboutInfo = (next) => setAboutInfo(next);

  const [loading] = useState(false);
  const [error] = useState(null);
  const [aboutLoading] = useState(false);

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            loggedInUser ? (
              <Home posts={posts} loading={loading} error={error} loggedInUser={loggedInUser} onLogout={handleLogout} />
            ) : (
              <Auth onLogin={handleLogin} onRegister={handleRegister} loggedInUser={loggedInUser} onLogout={handleLogout} />
            )
          }
        />

        <Route
          path="/auth"
          element={<Auth onLogin={handleLogin} onRegister={handleRegister} loggedInUser={loggedInUser} onLogout={handleLogout} />}
        />

        <Route
          path="/post/:id"
          element={<PostDetail posts={posts} loggedInUser={loggedInUser} onLogout={handleLogout} />}
        />

        <Route
          path="/archive"
          element={<Archive posts={posts} loading={loading} error={error} loggedInUser={loggedInUser} onLogout={handleLogout} />}
        />

        <Route
          path="/about"
          element={
            <About
              aboutInfo={aboutInfo}
              onUpdateAboutInfo={handleUpdateAboutInfo}
              loading={aboutLoading}
              canEdit={!!loggedInUser}
              onLogout={handleLogout}
              loggedInUser={loggedInUser}
            />
          }
        />

        <Route
          path="/write"
          element={
            loggedInUser ? (
              <WritePost onAddPost={handleAddPost} posts={posts} loggedInUser={loggedInUser} onLogout={handleLogout} />
            ) : (
              <Navigate to="/auth" replace />
            )
          }
        />

        <Route path="*" element={<NotFound loggedInUser={loggedInUser} onLogout={handleLogout} />} />
      </Routes>
    </Router>
  );
}
